import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled, { css } from 'styled-components';
const Navigation = styled.nav `
  display: block;
  margin-left: auto;

  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const NavigationList = styled.ul `
  display: flex;
  align-items: center;
`;
const NavigationItem = styled.li `
  display: block;

  & + & {
    margin-left: 24px;
  }

  @media ${from(Device.Desktop)} {
    & + & {
      margin-left: 54px;
    }
  }
`;
const NavigationLink = styled.a `
  display: block;
  color: currentColor;
  ${fonts.gotham.regular};
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0.05em;
  text-decoration: none;
  text-transform: uppercase;
  transition: color 0.15s ease-out;

  ${({ isActive }) => isActive &&
    css `
      ${fonts.gotham.bold};
      color: ${brand.green};
    `}

  &:focus,
  &:hover {
    color: ${brand.green};
  }

  @media ${from(Device.Desktop)} {
    font-size: 18px;
    line-height: 24px;
  }
`;
export default {
    Navigation,
    NavigationItem,
    NavigationLink,
    NavigationList,
};
